module.exports = __webpack_public_path__ + "static/media/NotoSans-SemiBoldItalic.f946221c.eot";